module.exports = __webpack_public_path__ + "images/marketing/import2-integration.png";